import React from 'react';
import { Route, Switch } from 'react-router-dom';
import OrganisationDetails from '../../../../mgmt/organisations/components/OrganisationDetails';
import PrincipalDetail from '../../../../mgmt/organisations/components/principals/PrincipalDetail';

const OrganisationScene = () => (
  <Switch>
    <Route
      exact
      path="/organisation/users/details/:actionId?/:tab?"
      component={PrincipalDetail}
      menuName="users"
    />
    <Route
      exact
      path="/organisation/:tab?/:action?/:actionId?"
      component={OrganisationDetails}
      menuName="users"
    />
  </Switch>
);

export default OrganisationScene;
